import { useEffect } from "react";
import PropTypes from "prop-types";

const HideNewHeaderOnScroll = ({
  handleClosePopover,
  headerClass = ".top-new-header",
}) => {
  useEffect(() => {
    const header = document.querySelector(headerClass);
    let lastScrollY = window.scrollY;

    const onScroll = () => {
      const currentY = window.scrollY;

      if (!header) return;

      const scrollingDown = currentY > lastScrollY;
      const scrollingUp = currentY < lastScrollY;

      if (scrollingDown && currentY > 100) {
        handleClosePopover && handleClosePopover();
        header.classList.add("hidden");
        header.classList.remove("visible");
      } else if (scrollingUp || currentY <= 50) {
        header.classList.remove("hidden");
        header.classList.add("visible");
      }

      lastScrollY = currentY;
    };

    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return null;
};

HideNewHeaderOnScroll.propTypes = {
  handleClosePopover: PropTypes.func,
  headerClass: PropTypes.string,
};

export default HideNewHeaderOnScroll;
